import { Controller } from "stimulus"
import isMobile from '../helpers/isMobile';
import Cookies from 'js-cookie'

export default class extends Controller {
  connect(){
    this.containerElement = this.element.closest("ul")
  }

  switch(event) {
    event.preventDefault()
    if (this.containerElement.classList.contains('professional-switcher--disabled')) {
      return
    }

    if (this.element.classList.contains('professional-switcher__item_active')) {
      return
    }

    this.containerElement.classList.add('professional-switcher--disabled')
    this.highlightSelectedProfessional()

    const errorMessage = document.querySelector('.message-professional-without-working-hours');
    const calendar = document.querySelector('#calendar');
    const hasWorkingHours = this.data.get('working-hours') !== '[]';
    Cookies.set("selected_professional_id", this.data.get('professional-id'))

    if (!hasWorkingHours) {
      errorMessage.querySelector('.no-working-hours-message-link').href = errorMessage.dataset
        .editWorkingHoursUrl
        .replace('professional_id_placeholder', this.data.get('professional-id'));

      errorMessage.classList.remove('tw-hidden')
      calendar.classList.add('tw-hidden')
      this.closeSidebar();
      this.containerElement.classList.remove('professional-switcher--disabled')
      return
    }

    errorMessage.classList.add('tw-hidden')
    calendar.classList.remove('tw-hidden')

    this.changeSelectedProfessionalIdToCalendar()
    $('#calendar').fullCalendar('removeEvents')
    $(".load-calendar").show()

    document.querySelector(".events-selected-professional").textContent = this.element.textContent

    $.ajax({
      dataType: "json",
      url: this.data.get("url"),
      data: this.params(),
      statusCode: {
        401: function() {
          document.location.reload(true)
        }
      }
    }).done((events) => {
      $(".load-calendar").hide()
      this.addWorkingHoursToCalendar()
      this.addEventsToCalendar(events)
      this.closeSidebar()
      document.dispatchEvent(new CustomEvent(
        this.data.get('professional-id') == 0 ? 'occupancyLevel/reset' : 'occupancyLevel/refresh',
        {
          detail: {
            professional_id: this.data.get('professional-id')
          }
        }
      ));

      document.dispatchEvent(new CustomEvent('calendar/professional-selected', {
        detail: {
          professionalId: this.data.get('professional-id')
        }
      }));
    }).always(() => {
      this.containerElement.classList.remove('professional-switcher--disabled')
    })
  }

  highlightSelectedProfessional() {
    $('.professional-switcher__item').removeClass('professional-switcher__item_active')
    $(this.element).addClass('professional-switcher__item_active')
  }

  changeSelectedProfessionalIdToCalendar() {
    $('#calendar').attr('data-selected-professional-id', this.data.get('professional-id'))
    window.agendaSelectedProfessionalId = this.data.get('professional-id')
  }

  params() {
    const start = $('#calendar').fullCalendar('getView').start.format()
    const end = $('#calendar').fullCalendar('getView').end.format()

    return { start: start, end: end }
  }

  addWorkingHoursToCalendar() {
    const openTime = this.data.get('open-time');
    const closeTime = this.data.get('close-time');

    $('#calendar')
      .data('open-time', openTime ? openTime : '07:00')
      .data('close-time', closeTime ? closeTime : '23:59')

    $('#calendar').fullCalendar('option', {
      businessHours: JSON.parse(this.data.get('working-hours')),
      minTime: openTime ? openTime : '07:00',
      maxTime: closeTime ? closeTime : '23:59'
    })
  }

  addEventsToCalendar(events) {
    if (events) {
      $('#calendar').fullCalendar('renderEvents', events)
      window.updateEventsCalendarOpeningHours(events)
    }
  }

  closeSidebar() {
    if (!isMobile()) {
      return;
    }

    const sidebarController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('#content > .tray'),
      'sidebar'
    )

    sidebarController.hide({
      preventDefault: function(){}
    })
  }
}
